import React, { useState } from "react";
import PropTypes from "prop-types";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import StopIcon from "@mui/icons-material/Stop";
import ArgoTextFieldHook from "../common/ArgoTextFieldHook";
import ArgoTextFieldSelectHook from "../common/ArgoTextFieldSelectHook";
import * as color from "../../constants/colorConstants";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities"

const ArgoColorInputHook = (props) => {
    const { 
        initToObj, 
        mode, 
        propsFieldName,
        defaultColorEntry, 
        defaultColorIndex,
        setColor,
        colorLabel,
        index,
        selectDefaultWidth,
        disabled,
        opacityFlag,
        height
    } = props;

    // Initialize state from props
    const getInitialState = () => {
        if (initToObj === null) {
            return {
                ...portalShared.customColorObject,
                colorTypes: [],
                colorValues: [],
                colorSelectHasFocus: false
            };
        } else {
            let initObj = initToObj.hasOwnProperty("colorObj") ? initToObj.colorObj : initToObj;
            let colorObj = portalShared.setCustomColorObject(initObj);
            return {
                ...colorObj,
                colorTypes: [],
                colorValues: [],
                colorSelectHasFocus: false
            };
        }
    };

    const [state, setState] = useState(getInitialState());

    const getCurrentCustomColorObj = () => {
        return portalShared.setCustomColorObject(state);
    };

    const onTextChange = (event, fieldName) => {
        const colorObj = getCurrentCustomColorObj();
        const value = event.target.value;
        colorObj[fieldName] = value;

        switch(fieldName) {
            case "opacityEntry":
                colorObj.opacityEntry = value;
                colorObj.opacity = value + "%";
                break;
            case "colorEntry":
                colorObj.colorEntry = value;
                break;
            default:
                console.log("ArgoColorInput.js  Switch default E01"); // eslint-disable-line
        }

        setState(colorObj);

        if (mode === "title") {
            setColor({colorObj: colorObj});
        } else {
            setColor(propsFieldName, colorObj);
        }
    };

    const onSelectColorChange = (fieldName, event) => {
        const colorObj = getCurrentCustomColorObj();
        colorObj[fieldName] = event.target.value;

        switch(fieldName) {
            case "colorType":
                switch (event.target.value) {
                    case "default":
                        Object.assign(colorObj, {
                            'colorType': event.target.value, 
                            'colorEntry': defaultColorEntry, 
                            'color': defaultColorEntry, 
                            'colorIndex': defaultColorIndex
                        });
                        break;
                    case "select":
                        Object.assign(colorObj, {
                            'colorType': event.target.value, 
                            'colorEntry': "black", 
                            'color': "#000000", 
                            'colorIndex': "0"
                        });
                        break;
                    case "hex":
                        Object.assign(colorObj, {
                            'colorType': event.target.value, 
                            'colorEntry': "#000000", 
                            'color': "#000000", 
                            'colorIndex': "0"
                        });
                        break;
                    case "rgb":
                        Object.assign(colorObj, {
                            'colorType': event.target.value, 
                            'colorEntry': "rgb(0,0,0)", 
                            'color': "rgb(0,0,0)", 
                            'colorIndex': "0"
                        });
                        break;
                    default:
                        console.log("ArgoColorInput.js  Switch default E02"); // eslint-disable-line
                }
                break;
            case "colorValue":
                const idx = color.standard.findIndex(object => {return object.color === event.target.value.color;});
                const selectedValue = color.standard[idx].hex;
                Object.assign(colorObj, {
                    'color': selectedValue, 
                    'colorIndex': idx, 
                    'colorEntry': color.standard[idx].color
                });
                break;
            // no default
        }

        setState(colorObj);

        if (mode === "title") {
            setColor({colorObj: colorObj});
        } else {
            setColor(propsFieldName, colorObj);
        }
    };

    const colorSelectFocused = () => {
        setState(prevState => ({ ...prevState, colorSelectHasFocus: true }));
    };

    const colorSelectBlurred = () => {
        setState(prevState => ({ ...prevState, colorSelectHasFocus: false }));
    };

    return (
        <React.Fragment>
            <ArgoTextFieldSelectHook
                fileName="ArgoColorInput"
                fieldName="colorType"
                index={index}
                label={colorLabel}
                value={state.colorType}
                width={selectDefaultWidth}
                onChange={(e) => onSelectColorChange("colorType", e)}
                menuItems={color.colorEntryTypes}
                disabled={disabled}
            />

            <div style={{width: "20px"}}></div>

            {
                (state.colorType !== "default") ?
                    (state.colorType === "select") ?
                        <div id="ArgoColorInput-color-selector" style={{marginBottom: "8px"}}>
                            <div style={{height: "12px", fontSize: "12px", color: state.colorSelectHasFocus ? "blue" : "#00000099"}}>Color Value</div>
                            <div style={{display: "flex"}}>
                                <Select 
                                    id={"color-input-color-name" + index}
                                    style={{width: "200px", paddingTop: "3px"}}
                                    label="Color Value"
                                    variant="standard"
                                    value={(state.colorType === "select") ? color.standard[state.colorIndex] : ""}
                                    onChange={(e) => onSelectColorChange("colorValue", e)}
                                    onFocus={colorSelectFocused}
                                    onBlur={colorSelectBlurred}
                                    disabled={disabled}
                                >
                                    {
                                        color.standard.map((c, index) => <MenuItem key={index} value={color.standard[index]}>
                                        {
                                            <div title={c.name} style={{display: "flex", alignItems: "center"}}>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <StopIcon style={{color: c.color}}/>
                                                </div>
                                                <div style={{color: c.name === "White" ? "Black" : c.color}}>{c.name}</div>
                                            </div>
                                        }
                                        </MenuItem>)
                                    }
                                </Select>
                                <div style={{width: "20px"}}></div>
                            </div>
                            {height !== '' ? <div style={{width: "20px", height: height}}></div> : ''}
                        </div>
                        :
                        <div style={{display: "flex"}}>
                            <ArgoTextFieldHook
                                fileName="ArgoColorInput"
                                fieldName="colorEntry"
                                index={index}
                                label={state.colorType === 'hex' ? "e.g. #FF0000" : "e.g. rgb(255,0,0)"}
                                value={state.colorEntry}
                                onChange={onTextChange}
                                width={200}
                                disabled={disabled}
                            />
                            <div style={{width: "20px"}}></div>
                        </div>
                    :
                    <div></div>
            }

            {opacityFlag ?
                    <ArgoTextFieldHook
                        fileName="ArgoColorInput"
                        fieldName="opacityEntry"
                        index={index}
                        type="number"
                        label="Opacity%"
                        value={state.opacityEntry}
                        onChange={onTextChange}
                        width={80}
                        disabled={disabled}
                        maxNum={100}
                    />
                :
                <div></div>
            }
        </React.Fragment>
    );
};

ArgoColorInputHook.defaultProps = {
    index: 0,
    mode: "title",
    colorLabel: "Color",
    opacityFlag: false,
    initToObj: null,
    largeHexEntry: true,
    disabled: false,
    height: "",
    defaultColorIndex: 0,
    defaultColorEntry: "black",
    selectDefaultWidth: 150
};

ArgoColorInputHook.propTypes = {
    index: PropTypes.number,
    mode: PropTypes.string,
    colorLabel: PropTypes.string,
    fieldName: PropTypes.string,
    opacityFlag: PropTypes.bool,
    setColor: PropTypes.func,
    initToObj: PropTypes.object,
    largeHexEntry: PropTypes.bool,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    defaultColorIndex: PropTypes.number,
    defaultColorEntry: PropTypes.string,
    selectDefaultWidth: PropTypes.number
};

export default ArgoColorInputHook;
